import {useStore} from "../store";
/**
 * 重置表彰
 * @param ref
 */

export function resetForm(ref){
    ref.resetFields()
}

/**
 * 判断是否拥有权限
 * @param per
 * @returns {boolean}
 */
export function hasPer(per){
    const store = useStore()
    const permission = store.permission
    return permission.indexOf(per) > -1
}

/**
 * 格式化日期时间
 * @param {Date} date 日期对象
 * @param {string} format 格式模板（默认：'yyyy-MM-dd HH:mm:ss'）
 * @returns {string} 格式化后的字符串
 */
export function formatDateTime(date, format = 'yyyy-MM-dd HH:mm:ss') {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return format
        .replace('yyyy', year)
        .replace('MM', month)
        .replace('dd', day)
        .replace('HH', hours)
        .replace('mm', minutes)
        .replace('ss', seconds);
}

/**
 * 检测操作系统类型 - 使用多种方法确保准确性
 * @returns {string} 'mac' | 'windows' | 'linux' | 'unknown'
 */
export function detectOperatingSystem() {
  try {
    // 方法1: 使用 navigator.userAgent (更现代的方法)
    const userAgent = navigator.userAgent.toLowerCase();
    
    if (userAgent.includes('mac os') || userAgent.includes('macintosh')) {
      return 'mac';
    }
    if (userAgent.includes('windows')) {
      return 'windows';
    }
    if (userAgent.includes('linux')) {
      return 'linux';
    }
    
    // 方法2: 使用 navigator.platform (作为备用)
    if (navigator.platform) {
      const platform = navigator.platform.toLowerCase();
      if (platform.includes('mac')) {
        return 'mac';
      }
      if (platform.includes('win')) {
        return 'windows';
      }
      if (platform.includes('linux')) {
        return 'linux';
      }
    }
    
    // 方法3: 使用 navigator.oscpu (仅限Firefox)
    if (navigator.oscpu) {
      const oscpu = navigator.oscpu.toLowerCase();
      if (oscpu.includes('mac')) {
        return 'mac';
      }
      if (oscpu.includes('windows')) {
        return 'windows';
      }
      if (oscpu.includes('linux')) {
        return 'linux';
      }
    }
    
    return 'unknown';
  } catch (error) {
    console.warn('OS detection failed:', error);
    return 'unknown';
  }
}

/**
 * 检测是否为Mac系统
 * @returns {boolean}
 */
export function isMacOS() {
  return detectOperatingSystem() === 'mac';
}

/**
 * 检测是否为Windows系统
 * @returns {boolean}
 */
export function isWindows() {
  return detectOperatingSystem() === 'windows';
}

/**
 * 获取快捷键显示文本
 * @param {string} key - 按键 (如 'I', 'O', 'P')
 * @returns {string} 格式化后的快捷键文本
 */
export function getShortcutText(key) {
  const os = detectOperatingSystem();
  const modifier = os === 'mac' ? 'option' : 'Alt';
  return `${modifier}+${key}`;
}